import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AccessPointContextProvider } from 'context/AccessPointContext';
import { BrandContextProvider } from 'context/BrandContext';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App/App';

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.ENVIRONMENT,
    release: process.env.APP_VERSION,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.01,
    enableLogs: true,
  });
}

document.addEventListener('securitypolicyviolation', e => {
  console.error(
    `[CSP violation] Blocked: ${e.blockedURI}\n` +
      `Directive: ${e.violatedDirective}\n\n` +
      `To fix:\n` +
      `  1. Add the domain to ALLOWED_DOMAINS in src/viteConfigUtils/csp.ts\n` +
      `  2. Notify IT to add it to UniFi pre-auth allowances for the relevant environment`
  );

  if (process.env.SENTRY_DSN) {
    Sentry.withScope(scope => {
      scope.setExtras({
        blockedURI: e.blockedURI,
        violatedDirective: e.violatedDirective,
        effectiveDirective: e.effectiveDirective,
        originalPolicy: e.originalPolicy,
        disposition: e.disposition,
        documentURI: e.documentURI,
      });
      Sentry.captureMessage(`CSP Violation: ${e.effectiveDirective} — ${e.blockedURI}`, 'warning');
    });
  }
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrandContextProvider>
      <QueryClientProvider client={queryClient}>
        <AccessPointContextProvider>
          <App />
        </AccessPointContextProvider>
      </QueryClientProvider>
    </BrandContextProvider>
  </StrictMode>
);
